export const textBoxesCopy = {
  lede: (provider: string, lineByLine: boolean) =>
    `Every piece of text ${provider} wrote, ${
      lineByLine ? 'line by line' : 'outlined on the page'
    }. Colored pieces broke ${provider}'s usual pattern.`,
  onThePage: 'On the page',
  lineByLine: 'Line by line',
  pageImage: 'Page image',
  pageOf: (page: number, total: number) => `Page ${page} of ${total}`,
  flagged: (count: number) => (count ? `${count} flagged` : 'None flagged'),
  previousPage: 'Previous page',
  nextPage: 'Next page',
  normal: 'Normal',
  asWritten: (provider: string) => `as ${provider} writes it`,
  alsoFound: 'Also found, no spot on the page',
  alsoFoundItem: (label: string, count: number | null) =>
    count === null ? label : `${label} · ${count.toLocaleString('en-US')}`,
  flaggedPiece: 'Flagged',
  noPageView: 'Page view not available yet',
  loadingPageView: 'Loading the page view…',
  empty: 'empty',
  blankSpaces: 'blank spaces',
  missing: 'The evidence for this check is no longer available.',
  failed: "The evidence for this check couldn't be loaded."
};
